import { Box } from '@material-ui/core';
import React from 'react';

export default ({ data }) => {
  const { campaignTitle, products, providerName } = data || {};
  const title = `${providerName ? `【${providerName}】 ` : ''}${campaignTitle}`;
  return (
    <>
      <Box fontWeight="bold">{title}</Box>
      { products.map((product, index) => {
        const { name, price, sellPrice } = product || {};

        return (
          <Box
            alignItems="center"
            display="flex"
            fontWeight="bold"
            justifyContent="space-between"
            key={name}
            fontSize={12}
          >
            <Box fontSize={16}>
              {index + 1}
              .
              {' '}
              {name}
            </Box>
            <Box flexShrink={0}>
              <Box style={{ textDecoration: 'line-through' }}>
                原價$
                {price}
              </Box>
              <Box
                alignItems="end"
                display="flex"
                flexShrink={0}
                fontWeight="bold"
              >
                <Box>折扣後</Box>
                <Box fontSize={16}>
                  {'$'}
                  {sellPrice}
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })}
    </>
  );
};
